module.exports = __webpack_public_path__ + "media/images/application/template/menu-e136da4d1747a82a65453150d63afed3.svg";